<template>
    <div class="sw-modal edit-form-component">
        <div class="sw-modal-content">
            <div class="row sw-modal-heading">
                <div class="col">
                    <h4 v-if="editingQuestion">Edit Question</h4>
                    <h4 v-if="isViewTemplateOrNew || (isViewEdit && !editingQuestion)">Add Question</h4>
                    <h4 v-if="isViewTemplateSelector">Choose a Question to copy</h4>
                </div>
            </div>

            <ValidationObserver ref="questionForm">
                <div class="sw-modal-body">
                    <div v-show="isViewTemplateOrNew" class="edit-form-component__template-or-new">
                        <div class="row question">
                            <div class="col-3">
                                <button class="btn btn-primary" v-on:click="showViewTemplateSelector()"><i class="fas fa-copy"></i></button>
                            </div>
                            <div class="col-9 question__question">
                                Copy from library<br/>
                                <span class="sw-modal-explanation">
                                    Save time by using a template<br/> (you can edit it afterwards)
                                </span>
                            </div>
                        </div>
                        <div class="row question">
                            <div class="col-12 question__question text-center">
                                or
                            </div>
                        </div>
                        <div class="row question">
                            <div class="col-3">
                                <button class="btn btn-secondary" v-on:click="showViewEdit()"><i class="far fa-file"></i></button>
                            </div>
                            <div class="col-9 question__question">
                                Blank question<br/>
                                <span class="sw-modal-explanation">
                                    Create your own
                                </span>
                            </div>
                        </div>
                    </div>


                    <div v-show="isViewTemplateSelector">
                        <div class="row question">
                            <div class="col-12 question__question">
                                Question
                            </div>
                            <div class="col-12">
                                <select v-model="questionTemplateReference">
                                    <option v-bind:value="null">Select a template</option>
                                    <template v-if="questionTemplatesBySection">
                                        <optgroup  v-for="(sectionQuestions) in questionTemplatesBySection" v-bind:key="sectionQuestions.name" v-bind:label="sectionQuestions.name">
                                            <option v-for="(template, index) in sectionQuestions.templates" v-bind:key="index" v-bind:value="template.reference">{{template.question}}</option>
                                        </optgroup>
                                    </template>
                                </select>
                            </div>
                        </div>
                        <div class="row question">
                            <div class="col-12 question__question">
                                Preview
                            </div>
                            <div class="col-12">
                                <div class="question__preview">
                                    <template v-if="questionTemplateReference === null">Select a template above to see a preview</template>
                                    <QuestionPreview v-show="questionTemplateReference !== null" v-bind:question="templateQuestionForPreview"></QuestionPreview>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div v-show="isViewEdit">
                        <div class="row question">
                            <div class="col-12 question__question">
                                Type
                            </div>
                            <div class="col-12">
                                <select v-model="question.type">
                                    <optgroup label="Guest questions">
                                        <option value="first-name">First name</option>
                                        <option value="last-name">Last name</option>
                                        <option value="mobile">Mobile</option>
                                        <option value="email">Email address</option>
                                        <option value="id-number">ID / passport number</option>
                                        <option value="date-of-birth">Date of birth</option>
                                        <option value="country">Country</option>
                                    </optgroup>
                                    <optgroup label="General questions">
                                        <option value="short-answer">Short answer</option>
                                        <option value="paragraph">Paragraph</option>
                                        <option value="checkboxes">Checkboxes (allows multiple selection)</option>
                                        <option value="multiple-choice">Multiple choice (single selection only)</option>
                                        <option value="dropdown">Dropdown</option>
                                        <option value="date">Date</option>
                                        <option value="time">Time</option>
                                        <option value="image">Image</option>
<!--                                        <option value="signature">Signature</option>-->
                                    </optgroup>
                                </select>
                            </div>
                        </div>
                        <div class="row question">
                            <div class="col-12 question__question">
                                Question
                                <markdown></markdown>
                            </div>
                            <div class="col-12">
                                <ValidationProvider rules="required" v-slot="{ errors }">
                                    <input type="text" v-model="question.question" class="short-question">
                                    <span class="text-error" v-if="errors">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="row question">
                            <div class="col-12 question__question">
                                Note text (optional)
                                <markdown></markdown>
                            </div>
                            <div class="col-12">
                                <textarea v-model="question.note" class="long-question"></textarea>
                            </div>
                        </div>
                        <div class="row question" v-if="askingPersonalInformation">
                            <div class="col-12 question__question">
                                Which guests do you want to ask?
                            </div>
                            <div class="col-12">
                                <select v-model="question.askQuestion">
                                    <option value="all-guests">All guests</option>
                                    <option value="adult-guests">Adults only</option>
                                    <option value="adult-first">First adult in each {{getUnitTypeForDisplay}}</option>
                                    <option value="adult-second">Second adult in each {{getUnitTypeForDisplay}}</option>
                                    <option value="adult-first-and-second">First and second adult in each {{getUnitTypeForDisplay}}</option>
                                    <option value="children-guests">Children only</option>
                                </select>
                            </div>
                        </div>
                        <div class="row question">
                            <div class="col-12">
                                <input type="checkbox" v-model="question.required"/>
                                <span class="question__question">
                                    Required
                                </span>
                            </div>
                        </div>
                        <div class="row question" v-if="question.type == 'paragraph' || question.type == 'short-answer' || question.type == 'email'">
                            <div class="col-12">
                                <input type="checkbox" v-model="question.copyable"/>
                                 <span class="question__question">
                                    Copyable
                                 </span>
                                ( <a href="#" class="sw-modal-explanation-link" v-on:click="showCopyableExplanation = !showCopyableExplanation">Why?</a> )
                            </div>
                            <div class="col-12 sw-modal-explanation" v-show="showCopyableExplanation">
                                Save guests time - if this is checked, guests can paste answers to this question in future questions
                            </div>
                        </div>
                        <div class="row question" v-if="question.type == 'checkboxes' || question.type == 'dropdown' || question.type == 'multiple-choice'">
                            <div class="col-12 question__question">
                                Answer options
                            </div>
                            <div class="col-12">
                                <div class="edit-dynamic-list">
                                    <Draggable v-model="question.options" group="options">
                                        <div v-for="(option, index) in question.options" v-bind:key="option" class="row edit-dynamic-list__item">
                                            <div v-show="editingOption(index)" class="col-12">
                                                <input type="text" v-model="newOptionText" class="short-question" ref="addOptionText" >
                                                <a v-on:click="updateOption" class="edit-dynamic-list__action edit-dynamic-list__action--yes"><i class="fas fa-check"></i></a>
                                                <a v-on:click="cancelEditOption" class="edit-dynamic-list__action edit-dynamic-list__action--no"><i class="fas fa-times"></i></a>
                                            </div>
                                            <div v-show="!editingOption(index)" class="col-12">
                                                {{option}}
                                                <a v-on:click="deleteOption(index)" class="edit-dynamic-list__action"><i class="fas fa-trash-alt"></i></a>
                                                <a v-on:click="showEditOption(index)" class="edit-dynamic-list__action"><i class="fas fa-edit"></i></a>
                                                <a class="edit-dynamic-list__action"><i class="fas fa-arrows-alt-v"></i></a>
                                            </div>
                                        </div>
                                    </Draggable>
                                    <div v-show="addingOption">
                                        <input type="text" v-model="newOptionText" class="short-question" ref="addOptionText" >
                                        <a v-on:click="addOption" class="edit-dynamic-list__action edit-dynamic-list__action--yes"><i class="fas fa-check"></i></a>
                                        <a v-on:click="cancelAdd" class="edit-dynamic-list__action edit-dynamic-list__action--no"><i class="fas fa-times"></i></a>
                                    </div>
                                    <div v-show="!addingOption">
                                        <a v-on:click="showAddOption" class="edit-dynamic-list__action edit-dynamic-list__action--add">+</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row question">
                            <div class="col-12 question__question">
                                Message on error / empty
                            </div>
                            <div class="col-12">
                                <input type="text" v-model="question.validationMessage" class="short-question"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sw-modal-actions">
                    <div v-if="updating || error" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                        {{infoMessage}}
                    </div>
                    <div v-show="updating && !success">
                        <Spinner/>
                    </div>
                    <div class="row" v-show="!updating && !success">
                        <div class="col text-center">
                            <button class="btn btn-secondary" v-on:click="cancel">Cancel</button>
                            <button class="btn btn-primary" v-show="isViewEdit" v-on:click="save">Save</button>
                            <button class="btn btn-primary" v-show="isViewTemplateSelector" v-on:click="copyTemplate" v-bind:disabled="questionTemplateReference === null">Copy & Edit</button>
                        </div>
                    </div>
                </div>

            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import Draggable from 'vuedraggable'

    import { store, getters } from '../../store.js'

    import { ValidationObserver, ValidationProvider } from 'vee-validate'

    import Spinner from '../Spinner.vue'
    import QuestionPreview from './QuestionPreview'
    import Markdown from '../Markdown'

    const SHOW_TEMPLATE_OR_NEW = 0, SHOW_TEMPLATE_SELECTOR = 1, SHOW_EDIT = 2;

    export default {
        name: 'EditQuestion',
        components: {
            Draggable, Spinner, QuestionPreview, Markdown, ValidationObserver, ValidationProvider
        },
        props: {
            formTemplateReference: String,
            formSectionReference: String,
            askingPersonalInformation: Boolean,
            question: Object,
            index: Number
        },
        data: function() {
            return {
                copy: {},
                view: SHOW_TEMPLATE_OR_NEW,
                showCopyableExplanation: false,
                addingOption: false,
                editingOptionIndex: null,
                newOptionText: "",
                updating: false,
                error: false,
                success: false,
                infoMessage: "Info message",
                disableDragging: false,
                questionTemplateReference: null,
                templateQuestions: [],
                questionTemplatesBySection: null
            }
        },
        computed: {
            editingQuestion: function () {
                if (typeof this.question.reference !== 'undefined') {
                    return true;
                }
                return false;
            },
            isViewTemplateOrNew: function() {
                return this.view === SHOW_TEMPLATE_OR_NEW;
            },
            isViewTemplateSelector: function() {
                return this.view === SHOW_TEMPLATE_SELECTOR;
            },
            isViewEdit: function() {
                return this.view === SHOW_EDIT;
            },
            templateQuestionForPreview: function() {
                if (this.questionTemplateReference !== null) {
                    for (let templateQuestion of this.templateQuestions) {
                        if (templateQuestion.reference === this.questionTemplateReference) {
                            return templateQuestion;
                        }
                    }
                }
                return null;
            },
            getUnitTypeForDisplay: function() {
                return getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes;
            }
        },
        methods: {
            showViewTemplateSelector: function() {
                this.view = SHOW_TEMPLATE_SELECTOR;
                this.fetchQuestionTemplates();
            },
            showViewEdit: function() {
                this.view = SHOW_EDIT;
            },
            showAddOption: function() {
                console.log("adding option");
                this.disableDragging = true;
                this.addingOption = true;
                setTimeout(() => {
                    this.$refs.addOptionText.focus();
                }, 500)
            },
            showEditOption: function(index) {
                console.log("editing option with index: " + index);
                this.editingOptionIndex = index;
                this.newOptionText = this.question.options[index];
                this.disableDragging = true;
            },
            cancelAdd: function() {
                this.addingOption = false;
                this.disableDragging = false;
            },
            addOption: function() {
                this.question.options.push(this.newOptionText);
                this.newOptionText = "";
                this.addingOption = false;
                this.disableDragging = false;
            },
            deleteOption: function(index) {
                console.log("deleting option with index: " + index);
                this.question.options.splice(index, 1);
            },
            editingOption: function(index) {
                return (this.editingOptionIndex !== null && this.editingOptionIndex === index);
            },
            updateOption: function() {
                this.question.options[this.editingOptionIndex] = this.newOptionText;
                this.editingOptionIndex = null;
                this.disableDragging = false;
            },
            cancelEditOption: function() {
                this.editingOptionIndex = null;
                this.disableDragging = false;
            },
            fetchQuestionTemplates: function() {
                console.log("fetching templates");
                this.$http.get('/guest-management/v1/establishments/' + store.currentEstablishmentReference + '/form-templates/question-templates', {
                    withCredentials: true
                }).then(response => {
                    if (response.data) {
                        this.templateQuestions = response.data;
                        // temporarily store in a map for grouping, but move to double array after for vue v-for (which doesn't handle maps in v2)
                        let groupedQuestionTemplates = new Map();
                        this.templateQuestions.forEach(template => {
                            if (!groupedQuestionTemplates.has(template.sectionType)) {
                                groupedQuestionTemplates.set(template.sectionType, { templates: []});
                            }
                            groupedQuestionTemplates.get(template.sectionType).templates.push(template);
                        });
                        this.questionTemplatesBySection = [];
                        groupedQuestionTemplates.forEach((sectionType, name) => {
                            let section = { name: this.getSectionName(name), templates: sectionType.templates};
                            this.questionTemplatesBySection.push(section);
                        });
                    }
                }).catch(error => {
                    console.log(error)
                }).finally(() => {
                })
            },
            getSectionName: function(sectionType) {
                let name = sectionType.replaceAll('-', ' ');
                name = name.charAt(0).toUpperCase() + name.slice(1);
                return name;
            },
            cancel: function() {
                console.log("cancel");
                this.question.question = this.copy.question;
                this.question.note = this.copy.note;
                this.question.type = this.copy.type;
                this.question.askQuestion = this.copy.askQuestion;
                this.question.required = this.copy.required;
                this.question.copyable = this.copy.copyable;
                if (this.copy.options && this.copy.options.length > 0) {
                    this.question.options = [];
                    this.question.options.push(...this.copy.options);
                }
                if (this.copy.validationMessage) {
                    this.question.validationMessage = this.copy.validationMessage;
                }
                this.$root.$emit('finished-editing-section-or-question');
                // if this is a new, unsaved question, then cancelling should remove it
                if (typeof this.question.reference === 'undefined') {
                    console.log("new - delete: " + this.formSectionReference + " :: " + this.index);
                    this.$root.$emit('delete-question-from-section', this.formSectionReference, this.index);
                }
            },
            copyTemplate: function() {
                if (this.questionTemplateReference !== null) {
                    for (let templateQuestion of this.templateQuestions) {
                        if (templateQuestion.reference === this.questionTemplateReference) {
                            this.$root.$emit('copy-template-info-question', this.formSectionReference, this.index, templateQuestion);
                            this.view = SHOW_EDIT;
                            return;
                        }
                    }
                }
            },
            save: function() {
                console.log("saving question");
                this.$refs.questionForm.validate().then(success => {
                    console.log("Validated:" + success);
                    if (!success) {
                        return
                    }

                    this.error = false;

                    let body = {
                        question: this.question.question,
                        note: this.question.note,
                        type: this.question.type,
                        required: this.question.required,
                        askQuestion: this.question.askQuestion,
                        copyable: this.question.copyable,
                        validationMessage: this.question.validationMessage,
                        options: []
                    };
                    if (this.question.options && this.question.options.length > 0) {
                        this.question.options.forEach((option) => {
                            body.options.push(option);
                        });
                    }

                    if (typeof this.question.reference === 'undefined') {
                        // adding a new question
                        this.updating = true;
                        this.infoMessage = "Creating question";
                        this.$http.post('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                            + '/form-templates/' + this.formTemplateReference
                            + "/section-templates/" + this.formSectionReference
                            + "/question-templates/index/" + this.index, body
                        ).then(response => {
                            console.log("Question created:");
                            console.log(response);
                            this.question.reference = response.data.reference;
                            console.log(this.question.reference);
                            this.infoMessage = "Question created";
                            this.success = true;
                            setTimeout(() => {
                                this.updating = false;
                                this.$root.$emit('finished-editing-section-or-question');
                            }, 2000);
                        }).catch(error => {
                            this.error = true;
                            this.updating = false;
                            if (error.response) {
                                this.infoMessage = "Error: " + error.response.data.message
                            } else {
                                this.infoMessage = "Error creating question";
                            }
                        });

                    } else {
                        // updating a question
                        this.updating = true;
                        this.infoMessage = "Saving question";
                        this.$http.put('/guest-management/v1/establishments/' + store.currentEstablishmentReference
                            + '/form-templates/' + this.formTemplateReference
                            + "/question-templates/" + this.question.reference, body
                        ).then(response => {
                            console.log("Question updated:")
                            console.log(response);
                            this.infoMessage = "Question updated"
                            this.success = true;
                            setTimeout(() => {
                                this.updating = false;
                                this.$root.$emit('finished-editing-section-or-question');
                            }, 2000);
                        }).catch(error => {
                            this.error = true;
                            this.updating = false;
                            if (error.response) {
                                this.infoMessage = "Error: " + error.response.data.message
                            } else {
                                this.infoMessage = "Error updating question";
                            }
                        });
                    }
                });
            }
        },
        mounted() {
            console.log("Mounting edit / add question");
            this.copy.question = this.question.question;
            this.copy.note = this.question.note;
            this.copy.type = this.question.type;
            this.copy.askQuestion = this.question.askQuestion;
            this.copy.required = this.question.required;
            if (this.question.copyable) {
                this.copy.copyable = this.question.copyable;
            }
            if (this.question.options.length > 0) {
                this.copy.options = [];
                this.copy.options.push(...this.question.options);
            }
            if (this.question.validationMessage) {
                this.copy.validationMessage = this.question.validationMessage;
            }
            if (typeof this.question.reference === 'undefined') {
                this.view = SHOW_TEMPLATE_OR_NEW;
            } else {
                this.view = SHOW_EDIT;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/modal";
    @import "../../styles/components/edit_form_component";
    @import "../../styles/components/question_answer";
    @import "../../styles/layout/tooltips";
</style>